<template>
    <div class="row marketing">
      <div class="col-lg-12">
        <div style="margin-bottom:2em;" v-html="chapterdata.chapterDescription"></div>
        <div v-for="item in chapterdata.chapterMaterials" style="margin-bottom:1em;">
          <div v-if="!item.materialAdditional">
            <div class="card w-100">
              <div class="card-body">
                <h4 class="card-title">{{item.materialTitle}}</h4>
                <h6 style="color:rgba(0,0,0,.2)!important" class="card-subtitle mb-2 text-muted">{{item.materialSubtitle}}
                <span><i class="fa fa-clock-o" aria-hidden="true"></i> {{ item.materialTime }} min</span>
                </h6>
                <p class="card-text" >{{item.materialDescription}}</p>
                
                <div v-if="item.materialType === 'embeded'"> 
                  <div class="embed-responsive embed-responsive-16by9" >
                     <iframe class="embed-responsive-item" v-bind:src='item.materialLink'></iframe>
                  </div>    
                </div>
                <div v-else style="text-align:center">
                  <a :href="item.materialLink" target="_blank" class="btn btn-outline-primary">Read Article</a>
                </div>   
              </div>
            </div>
          </div>
        </div> 
        <div v-for="item in chapterdata.chapterMaterials" style="margin-bottom:1em;">
            <div v-if="item.materialAdditional">
              <h4 style="margin-top:1em;color:rgba(0,0,0,.2)">Additional Material:</h4>
              <div class="card w-100">
                <div v-if="item.materialAdditional" class="card-body">
                  <h4 class="card-title">{{item.materialTitle}}</h4>
                  <h6 style="color:rgba(0,0,0,.2)!important" class="card-subtitle mb-2 text-muted">{{item.materialSubtitle}}
                  <span><i class="fa fa-clock-o" aria-hidden="true"></i> {{ item.materialTime }} min</span>
                  </h6>
                  <p class="card-text" >{{item.materialDescription}}</p>
                  
                  <div v-if="item.materialType === 'embeded'"> 
                    <div class="embed-responsive embed-responsive-16by9" >
                       <iframe class="embed-responsive-item" v-bind:src='item.materialLink'></iframe>
                    </div>    
                  </div>
                  <div v-else style="text-align:center">
                    <a :href="item.materialLink" target="_blank" class="btn btn-outline-primary">Read Article</a>
                  </div>   
                </div>
              </div>
            </div>
        </div> 
        <div style="margin-bottom:2em">
          <i style="color:rgba(0,0,0,.2); font-weight:bold">If you have any suggestions for additional material that we should include in this chapter, or criticism on the existing ones please get in touch with us on <a style="color:rgba(0,0,0,.4)" href="https://t.me/dacade">telegram</a>! We are very grateful for all suggestions.</i>
        </div>

        <a class="btn btn-outline-primary btn-lg btn-block" @click="NextChapterView(chapterdata)">
          Next: Assignment
        </a>
      </div>
    </div>

    
</template>

<script>

export default {
  props:['chapterdata'],
  methods: {
    NextChapterView(chapterdata) {
      this.$router.push({path: '/course/' + chapterdata.lCId + '/chapter/' + chapterdata.id + '/assignment/'});
    }
  }
}
</script>

<style type="text/css">
  
</style>


// WEBPACK FOOTER //
// src/components/course/chapter/ChapterMaterials.vue